import { useState } from "react";

const ToggleViewContainer = ({
  show,
  leftLabel,
  rightLabel,
  LeftComponent,
  RightComponent,
  defaultLeft = true,
  width = "w-full",
  height = "h-full",
}) => {
  const [isLeft, setIsLeft] = useState(defaultLeft);

  return (
    <div
      className={`relative bg-white rounded-md md:w-full ${width} ${height}`}
    >
      {!show && (
        <div className="absolute top-2 right-4 gap-1 flex items-center z-10">
          <span className="mr-2 text-gray-700 md:text-sm text-[11px]">
            {isLeft ? leftLabel : rightLabel}
          </span>

          <label className="relative inline-block w-10 select-none">
            <input
              type="checkbox"
              checked={isLeft}
              onChange={() => setIsLeft(!isLeft)}
              className="absolute w-6 h-6 rounded-full appearance-none cursor-pointer transition-transform duration-200"
            />

            <span
              className={`block h-6 rounded-full cursor-pointer ${
                isLeft ? "bg-[#AAE0D3]" : "bg-[#b9b8f4]"
              }`}
            >
              <span
                className={`block h-5 w-5 rounded-full shadow-md transform transition-transform duration-200 translate-y-0.5 ${
                  isLeft
                    ? "bg-[#599f8e] translate-x-full"
                    : "bg-[#8381fe] translate-x-0"
                }`}
              />
            </span>
          </label>
        </div>
      )}

      <div className="h-full">
        {isLeft ? <LeftComponent /> : <RightComponent />}
      </div>
    </div>
  );
};

export default ToggleViewContainer;
